import { DatePickerProps } from 'antd/es/date-picker';
import moment from 'moment';

export interface CustomDatePickerConfig {
  format: string;
  showTime?: boolean | { format?: string; defaultValue?: moment.Moment };
}

export type CustomDatePickerProps = Omit<DatePickerProps, 'format' | 'showTime'> & {
  config?: Partial<CustomDatePickerConfig>;
};

export const defaultDatePickerConfig: CustomDatePickerConfig = {
  format: 'YYYY-MM-DD HH:mm',
  showTime: {
    defaultValue: moment('00:00:00', 'HH:mm'),
  },
};
